import useSnackbarStore from '@store/snackbar-store/snackbar.store.ts';
import { SnackbarType } from '@models/app-snackbar.model.ts';

function SnackbarComponent() {
  const { showSnackbar } = useSnackbarStore();
  return (
    <div className="flex items-center gap-6">
      <button
        className="px-4 py-2 bg-green-500 text-white rounded cursor-pointer hover:bg-green-600"
        onClick={() => showSnackbar('Success message!', SnackbarType.Success)}
      >
        Success
      </button>

      <button
        className="px-4 py-2 bg-red-500 text-white rounded cursor-pointer hover:bg-red-600"
        onClick={() => showSnackbar('Error message!', SnackbarType.Error)}
      >
        Error
      </button>

      <button
        className="px-4 py-2 bg-yellow-500 text-white rounded cursor-pointer hover:bg-yellow-600"
        onClick={() => showSnackbar('Warning message!', SnackbarType.Warning)}
      >
        Warning
      </button>
    </div>
  );
}

export default SnackbarComponent;
